export default "__VITE_ASSET__BQx2H1_e__"